var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPenWithSquare = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.6109 3.98543L5.00705 11.7239L5.00005 15.0322L8.30838 15.0393L15.9122 7.30077L12.6109 3.98543ZM7.57987 13.2733L6.76822 13.2715L6.76994 12.4599L12.6056 6.48212L13.4156 7.29548L7.57987 13.2733ZM18.5292 4.69492C18.8739 4.35158 18.8751 3.79578 18.5318 3.45099L16.4718 1.38222C16.1284 1.03742 15.5726 1.03625 15.2278 1.37959L13.495 3.10508L16.7963 6.42041L18.5292 4.69492Z",
  fill: "#35336C"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M17 8.09995V17.0999H3V3.09995H11.5714L11.75 2.84995L13.2079 1.39209C12.8986 1.20183 12.5392 1.09995 12.17 1.09995H3C1.9 1.09995 1 1.99995 1 3.09995V17.0999C1 18.1999 1.9 19.0999 3 19.0999H17C18.1 19.0999 19 18.1999 19 17.0999V7.92994C19 7.44013 18.8206 6.96739 18.4935 6.60646L17 8.09995Z",
  fill: "#35336C"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M15 13.0999V15.0999H5M15 9.09995V11.0999M5 5.09995H10.4444M12.6109 3.98543L5.00705 11.7239L5.00005 15.0322L8.30838 15.0393L15.9122 7.30077L12.6109 3.98543ZM7.57987 13.2733L6.76822 13.2715L6.76994 12.4599L12.6056 6.48212L13.4156 7.29548L7.57987 13.2733ZM18.5292 4.69492C18.8739 4.35158 18.8751 3.79578 18.5318 3.45099L16.4718 1.38222C16.1284 1.03742 15.5726 1.03625 15.2278 1.37959L13.495 3.10508L16.7963 6.42041L18.5292 4.69492ZM17 8.09995V17.0999H3V3.09995H11.5714L11.75 2.84995L13.2079 1.39209C12.8986 1.20183 12.5392 1.09995 12.17 1.09995H3C1.9 1.09995 1 1.99995 1 3.09995V17.0999C1 18.1999 1.9 19.0999 3 19.0999H17C18.1 19.0999 19 18.1999 19 17.0999V7.92994C19 7.44013 18.8206 6.96739 18.4935 6.60646L17 8.09995Z",
  stroke: "white",
  strokeWidth: 0.3
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPenWithSquare);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/penWithSquare.cc0e431c1b6b80d5e515575519467503.svg";